import React from "react";
import { withUserProfile } from "../../../../../../userProfile/userProfileContext";
import { withStyles } from "@material-ui/core";
import { compose } from "recompose";
import { getDataWithQueryString } from "../../../../../../api/componentAPIs";
import DataGrid from '@dataGrid';
import GridConfig from "./GridConfig";
import styles from "./../styles";
import { withSnackbar } from "notistack";
import { csvFormulaInjectionSanitizer } from "../../../../../../utilities/csvUtils";
import StatusBar from '@dataGrid/components/StatusBar';
import GridHeader from "../GridHeader";
import Events from "../../../../../../utilities/EventEmitter";
import { getUniqueKeyForStripPriorityRowData, appendTimeInMinutesToDate } from "../../utils";
import { sortBy } from "lodash";
import appConstants from "../../../../../../appConstants";
import { PrintReport } from "../../../../../common";
import { getDisplayedRowData } from "../../../../../common/PrintReport/utils/reportDataFormatter";

class Trailers extends React.Component {
  constructor(props) {
    super(props);
    this.gridApi = null;
    this.state = {
      trailersData: null,
      quickFilterText: "",
      showMergeCustomerAlert: false,
      dockStartTime: this.getFormattedDockStartTime(),
      errorMessage: appConstants.GRID_STATUS.LOADING,
    };
    this.selectedTrailers = [];
    this.printRef = React.createRef(null);
    this.beforePrintFn = null;
    this.gridConfig = new GridConfig({
      terminal: this.props.userData.userProfile.terminal.code,
      userConfig: this.props.userData.userProfile?.columnPref
    });
    this.headerId="StripPriority"
  }
  onGridReady = ({ api }) => {
    this.gridApi = api;
  };

  componentDidMount() {
    this._isComponentMounted = true;
    this.getStripPriorityTrailers();
  }

  componentWillUnmount() {
    this._isComponentMounted = false;
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.userData.userProfile.terminal.id !== prevProps.userData.userProfile.terminal.id
    ) {
      this.getStripPriorityTrailers();
    }
  }

  setSelectTrailers = () => {
    if (!this.gridApi?.forEachNode) {
      return;
    }
    this.gridApi.forEachNode((node) => {
      const trailerUniqueCode = getUniqueKeyForStripPriorityRowData(node.data.trailerNumber, node.data.trailerScac);
      if (this.selectedTrailers.includes(trailerUniqueCode)) {
        node.setSelected(true); // props are isSelected, clearOtherSelection, suppressFinishActions
        if (this.gridApi.ensureIndexVisible) {
          this.gridApi.ensureIndexVisible(node.rowIndex);
        }
      }
    });
  };

  getFormattedDockStartTime = () => {
    const {planDate, defaultDockStartTimeInMins=0} = this.props.userData.userProfile;
    return appendTimeInMinutesToDate(planDate, defaultDockStartTimeInMins);
  }

  updateQuickFilterText = (searchText) => {
    this.setState({
      quickFilterText: searchText,
    });
  };

  exportCSV = () => {
    if (!this.state.trailersData?.length || !this.gridApi) {
      return;
    }
    const columns = this.gridApi.getColumns();
    const columnKeys = columns
      .filter(column => !column.colDef.hide)
      .map(column => column.getColId());

    const params = {
      fileName: "Strip_Priority_Trailers_Report",
      columnKeys,
      processCellCallback: (cell) => csvFormulaInjectionSanitizer(cell.value),
    };
    this.gridApi.exportDataAsCsv(params);
  };

  setGridStatusToLoading = () => {
    this.setState({
      trailersData: null,
      errorMessage: appConstants.GRID_STATUS.LOADING,
    });
  };

  getStripPriorityTrailers = () => {
    this.setGridStatusToLoading();
    const userProfile = this.props.userData?.userProfile; 
    const { terminal, planDate } = userProfile || {};
    const { id:terminalId } = terminal || {};
    getDataWithQueryString(
      "GetStripPriorityTrailers",
      `dockStartTime=${this.state.dockStartTime}&planDate=${planDate}&terminalId=${terminalId}`
    ).then(
      (response) => {
        if (!this._isComponentMounted) {
          return;
        }
        if (response.status === 200) {
          this.setState({
            trailersData: sortBy(response.data, "unldgRanking"),
            errorMessage: appConstants.GRID_STATUS.SUCCESS,
          });
          this.resetRefreshBarTimer();
          this.setSelectTrailers();
          return;
        }
        this.handleError();
      },
      (_error) => {
        if (this._isComponentMounted) {
          this.handleError();
        }
      }
    );
  };

  handleError = () => {
    this.props.enqueueSnackbar("Unable to fetch strip priority trailers data", {
      variant: "error",
    });
    this.setState({
      trailersData: [],
      errorMessage: appConstants.GRID_STATUS.ERROR,
    });
  };

  resetRefreshBarTimer = () => {
    Events.emit(`ResetRefreshBarTimer-${this.headerId}`);
  }

  constructStatusBar = (filteredData) => {
    return [
      {
        label: `${filteredData.length || 0} Total Trailers`,
        filterCondition: "",
      },
    ];
  };

  updatedSelectedTrailers = () => {
    this.selectedTrailers = this.gridApi.getSelectedRows().map((trailer) => {
      const { trailerNumber, trailerScac } = trailer;
      return getUniqueKeyForStripPriorityRowData(trailerNumber, trailerScac);
    });
  };

  onSelectionChanged = (params) => {
    this.updatedSelectedTrailers();
    Events.emit("UpdateSelectedTrailersShipments", this.selectedTrailers);
  };

  handleRefreshClick = () => {
    this.getStripPriorityTrailers();
    Events.emit("RefreshStripPriorityShipments");
  };

  setPrintRef = (compRef, beforePrintFn) => {
    this.printRef = compRef;
    this.beforePrintFn = beforePrintFn;
  }

  getPrintDataFn = () => {
    const rowData = [];
    this.gridApi.forEachNodeAfterFilterAndSort((node) => {
      rowData.push(node.data);
    })
    return getDisplayedRowData({
      headerProps: {
        title: "IB Trailer Strip Priority",
        headerDetails: [
          {
            label: rowData?.length || 0,
            value: "Total Trailers",
          },
        ],
      },
    });
  }
 
  render() {
    const { classes, toggleMaximize, isMaximized } = this.props;
    const { config } = this.gridConfig;
    return (
      <>
        <div className={classes.trailerContainer}>
          <GridHeader
            exportCSV={this.exportCSV}
            title="IB Trailer Strip Priority"
            updateQuickFilterText={this.updateQuickFilterText}
            showPrint
            gridApi={this.gridApi}
            handleRefreshClick={this.handleRefreshClick}
            onBeforeGetContent={this.beforePrintFn}
            printRef={this.printRef}
            toggleMaximize={toggleMaximize}
            isMaximized={isMaximized}
            headerId={this.headerId}
          />
          <div>
            <div className={`${classes.dataGrid} ${isMaximized ? '' : classes.trailerGridHeight}`}>
              <DataGrid
                columnDefs={config.columns}
                config={config}
                rowData={this.state.trailersData}
                enableSorting={config.enableSorting}
                onGridReady={this.onGridReady}
                quickFilterText={this.state.quickFilterText}
                rowSelection={this.gridConfig.config.rowSelection}
                rowDeselection={this.gridConfig.config.rowDeselection}
                onSelectionChanged={this.onSelectionChanged}
                onCellMouseDown={this.onCellFocused}
                onRowClicked={this.onRowClicked}
                showErrorMessage={this.state.errorMessage}
                panelLabel={(filteredData) => <StatusBar data={this.constructStatusBar(filteredData)} />}
              />
            </div>
          </div>
        </div>
        <PrintReport
          gridApi={this.gridApi}
          setPrintRef={this.setPrintRef}
          getPrintDataFn={this.getPrintDataFn}
        />
      </>
    );
  }
}
export default compose(
  withStyles(styles),
  withUserProfile,
  withSnackbar
)(Trailers);
